import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, renderList as _renderList, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "row q-gutter-sm justify-end" };
const _hoisted_2 = { style: { "width": "350px" } };
const _hoisted_3 = { class: "" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = {
    key: 0,
    class: "note",
    style: { "font-size": "14px" }
};
const _hoisted_7 = { class: "note" };
const _hoisted_8 = { class: "q-pl-md" };
const _hoisted_9 = { key: 1 };
const _hoisted_10 = {
    key: 0,
    class: "row"
};
const _hoisted_11 = { class: "dlg-content" };
const _hoisted_12 = { class: "q-ml-md q-mt-sm" };
const _hoisted_13 = { class: "q-pa-sm" };
const _hoisted_14 = { class: "row q-pa-sm" };
const _hoisted_15 = { class: "dlg-actions" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_RoomSelectCard = _resolveComponent("RoomSelectCard");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_dialog = _resolveComponent("q-dialog");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.auth.userInfo.userType == _ctx.userType.hojin)
            ? (_openBlock(), _createBlock(_component_q_card_section, {
                key: 0,
                class: ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_q_input, {
                                dense: "",
                                outlined: "",
                                clearable: "",
                                "clear-icon": "close",
                                modelValue: _ctx.condition.keyword,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.condition.keyword) = $event)),
                                "no-error-icon": "",
                                error: _ctx.conditionValid.keyword.error,
                                "error-message": _ctx.conditionValid.keyword.message
                            }, null, 8, ["modelValue", "error", "error-message"])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_q_btn, {
                                icon: "search",
                                class: "col-8 col-sm-6 col-md-3 col-lg-3",
                                label: "検索",
                                color: "green-7",
                                onClick: _ctx.onSearch
                            }, null, 8, ["onClick"])
                        ])
                    ])
                ]),
                _: 1
            }))
            : _createCommentVNode("", true),
        _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "table-caption" }, "下記部屋より選択をしてください。", -1)),
                (_ctx.hasParking)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_ctx.isTaikyo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                (_ctx.isMobile)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.taikyoMobilCaption), 1))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.taikyoCaption), 1),
                                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.taikyoParkingCaption), 1)
                                    ], 64))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", {
                                    class: "note",
                                    style: _normalizeStyle(_ctx.isMobile ? 'font-size: 14px' : '')
                                }, _toDisplayString(_ctx.shomeiParkingCaption), 5)
                            ]))
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                        (_ctx.auth.userInfo.userType === _ctx.userType.Kojin)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewModels, (vm, index) => {
                                    return (_openBlock(), _createBlock(_component_RoomSelectCard, {
                                        key: index,
                                        viewModel: vm,
                                        onClick: ($event) => (_ctx.cardOrRowClick(vm.model.orgNyukyokeiyakuNo))
                                    }, null, 8, ["viewModel", "onClick"]));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createVNode(_component_q_dialog, {
                    class: "mypage-dialog dlg--no-title dlg--open",
                    "transition-duration": "200",
                    "transition-hide": "fade",
                    modelValue: _ctx.confirmDialog,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.confirmDialog) = $event))
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card, { class: "dlg-wrapper" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_11, [
                                    _cache[6] || (_cache[6] = _createTextVNode(" 下記の部屋でよろしいでしょうか ", -1)),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                            _createVNode(_component_q_icon, {
                                                size: "1.5em",
                                                name: _ctx.dialogNyukyokeiyaku.roomSb === _ctx.RoomSb.Parking ? 'directions_car' : 'maps_home_work',
                                                color: "grey-7"
                                            }, null, 8, ["name"]),
                                            _cache[4] || (_cache[4] = _createElementVNode("span", null, "   ", -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.dialogNyukyokeiyaku.bukkenNameWithRoom), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createVNode(_component_q_icon, {
                                                size: "1.5em",
                                                name: "perm_identity",
                                                color: "grey-7"
                                            }),
                                            _cache[5] || (_cache[5] = _createElementVNode("span", null, "   ", -1)),
                                            _createElementVNode("div", null, _toDisplayString(_ctx.dialogNyukyokeiyaku.nyukyosha), 1)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_component_q_btn, {
                                        class: "dlg-action cancel-action",
                                        flat: "",
                                        label: "キャンセル",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.confirmDialog = false))
                                    }),
                                    _createVNode(_component_q_btn, {
                                        class: "dlg-action ok-action",
                                        flat: "",
                                        label: "OK",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.onPush(_ctx.selectedNyukyoKeiyakuNo)))
                                    })
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]),
            _: 1
        })
    ], 64));
}
